<template>
  <div id="dashboard-home">
    <h1>{{ currentList.title }}</h1>

    <!-- Spinner -->
    <transition name="fade">
      <RingLoader v-if="performingRequest" :color="this.spinnerColor" :size="this.spinnerSize"></RingLoader>
    </transition>

    <!-- Figures -->
    <div class="row">
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            Costs
          </div><!-- /.card-header -->
          <div class="card-body">
            <h2>$<animated-number :value="cost" :formatValue="formatFigure" :duration="1500" /></h2>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-3 -->
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            Private Investment
          </div><!-- /.card-header -->
          <div class="card-body">
            <h2>$<animated-number :value="privateFunds" :formatValue="formatFigure" :duration="1500" /></h2>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-3 -->
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            Local Investment
          </div><!-- /.card-header -->
          <div class="card-body">
            <h2>$<animated-number :value="localFunds" :formatValue="formatFigure" :duration="1500" /></h2>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-3 -->
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            Grant Funds
          </div><!-- /.card-header -->
          <div class="card-body">
            <h2>$<animated-number :value="grantFunds" :formatValue="formatFigure" :duration="1500" /></h2>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-3 -->
    </div><!-- /.row -->


    <div class="row">
      <!-- List -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            Recent
          </div>
          <div class="card-body" id="recent-list">
            <p v-for="post in posts.slice(0, 10)"><router-link :to="{ name: 'Post', params: {id: post.id} }"><i class="fas fa-map-marker"></i> {{ post.title }}</router-link></p>
            </ul>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-md-4 -->
      <!-- Map -->
      <div class="col-md-8">
        <div class="card">
          <div id="home-map"></div>
          <!-- The map legend -->
          <div id="home-legend">
            <span class="legend-dot proposed"></span> Proposed<br>
            <span class="legend-dot underway"></span> Underway<br>
            <span class="legend-dot complete"></span> Complete
          </div><!-- /#legend -->
        </div><!-- /.card -->
      </div><!-- /.col-md-8 -->
    </div><!-- /.row -->
    <!-- Timeline -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Timeline
          </div>
          <div id="home-timeline"></div>
        </div>
      </div><!-- /.col-md-12 -->
    </div><!-- /.row -->
  </div><!-- /#dashboard-home -->
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  import AnimatedNumber from "animated-number-vue"
  import RingLoader from 'vue-spinner/src/RingLoader.vue'
  const fb = require('../firebaseConfig.js')

  export default {
    data() {
      return {
        cost: 0,
        grantFunds: 0,
        privateFunds: 0,
        localFunds: 0,
        performingRequest: true,
        spinnerColor: '#2674a3',
        spinnerSize: '50px'
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser', 'posts', 'currentList'])
    },
    components: { AnimatedNumber, RingLoader },
    created: function() {
      let self = this
      if (self.$route.name == 'Visualization' && self.$route.params.mode == 'user') {
        let userData
        fb.usersCollection.doc(self.$route.params.id).get().then(res => {
          userData = res.data()
          self.$store.dispatch('setCurrentList', {title: userData.company})
          console.log(userData)
        }).catch(err => {
          console.log(err)
        })
      }

      setTimeout(function() {
        if (self.$route.name == 'Dashboard') {
          self.$store.dispatch('setCurrentList', {title: self.userProfile.company})
        }

        self.initDashboardHome()
        self.performingRequest = false
      }, 2000)
    },
    methods: {
      formatFigure(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      formatDateSeconds(val) {
        if (!val) { return null }
        let date = val.toDate()
        return moment(date).unix()
      },
      formatFullDate(val) {
        if (!val) { return '-' }
        let date = val.toDate()
        let year = moment(date).year()
        let month = moment(date).month() + 1
        let day = moment(date).date()
        let completeDate = year + '/' + month + '/' + day
        return completeDate
      },
      getNow() {
        return moment().unix()
      },
      initDashboardHome() {

        // MAP
        let postsMap = null;
        let self = this;

        let mapStyles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]

        setTimeout(function () {
          postsMap = new google.maps.Map(document.getElementById('home-map'), {
            center: {lat:0,lng:0},
            zoom: 2,
            styles: mapStyles,
            gestureHandling: 'cooperative'
          });
          var infowindow = new google.maps.InfoWindow();
          var bounds = new google.maps.LatLngBounds();

          //Get legend and push it to the map
          var legend = document.getElementById('home-legend');
          postsMap.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);

          // Loop through the posts
          for (var i = 0; i < self.posts.length; i++) {

          // Create the marker
          var marker = new google.maps.Marker({
            icon: {
              path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
              fillColor: '#2674a3',
              fillOpacity: 0.8,
              scale: 0.5,
              strokeColor: 'white',
              strokeWeight: 2
            },
            position: new google.maps.LatLng(self.posts[i].coordinates.latitude, self.posts[i].coordinates.longitude),
            map: postsMap,
            title: self.posts[i].title
          });

            // Get point start and end dates
            var startDate = self.formatDateSeconds(self.posts[i].dates.start)
            var endDate = self.formatDateSeconds(self.posts[i].dates.end)
            var now = self.getNow()
            // Compare those dates to now and assign color based on past, present, future
            if (startDate == null) {
              marker.icon.fillColor = '#2674a3'
            } else if (startDate > now) {
              marker.icon.fillColor = '#69D2E7'
            } else if (endDate < now) {
              marker.icon.fillColor = '#FA6900'
            } else if (startDate < now && endDate > now) {
              marker.icon.fillColor = '#E0E4CC'
            }

            // Add figures to totals
            self.cost = self.cost + self.posts[i].figures.cost.value
            self.grantFunds = self.grantFunds + self.posts[i].figures.grantFunds.value
            self.privateFunds = self.privateFunds + self.posts[i].figures.privateFunds.value
            self.localFunds = self.localFunds + self.posts[i].figures.localFunds.value

            bounds.extend(new google.maps.LatLng(self.posts[i].coordinates.latitude, self.posts[i].coordinates.longitude));
            google.maps.event.addListener(marker, 'click', (function(marker, i) {

              // Setup info window content
              function imageThumb(i) {
                if (self.posts[i].media[0]) {
                  return '<div class="map-popup-thumb"><a href="/post/' + self.posts[i].id + '" target="_blank"><img src="' + self.posts[i].media[0].medium + '"></a></div>'
                } else {
                  return ''
                }
              }
              var infowindowContent = '<div class="map-popup">' + imageThumb(i) + '<a href="/post/' + self.posts[i].id + '" target="_blank"><h2>' + self.posts[i].title + '</h2></a>' + self.posts[i].body + '</div><!-- /.map-popup -->'

              return function() {
                infowindow.setContent(infowindowContent);
                infowindow.open(postsMap, marker);
              }
            })(marker, i));
          } // End Loop
          postsMap.fitBounds(bounds);
        }, 50);

        // Timeline
        setTimeout(function () {
          var datesArray = []
          // DOM element where the Timeline will be attached
          document.getElementById('home-timeline').innerHTML = "";
          var container = document.getElementById('home-timeline');

          // Prepare the datesArray
          var i;
          for (i = 0; i < self.posts.length; i++) {
            let postItemId = i + 1;
            let postItemContent = self.posts[i].title
            let postItemStart = self.formatFullDate(self.posts[i].dates.start)
            let postItemEnd = self.formatFullDate(self.posts[i].dates.end)
            let postItemStartEndObj = {id: postItemId, content: postItemContent, start: postItemStart, end: postItemEnd}
            let postItemStartObj = {id: postItemId, content: postItemContent, start: postItemStart}

            if (self.posts[i].dates.start != null && self.posts[i].dates.end != null) {
              if (postItemStart === postItemEnd) {
                datesArray.push(postItemStartObj)
              } else {
                datesArray.push(postItemStartEndObj)
              }
            }

          }

          // Create a DataSet (allows two way data-binding)
          var items = new vis.DataSet(datesArray);

          // Configuration for the Timeline
          var options = {
            height: '400px',
            zoomable: false
          };

          // Create a Timeline
          var timeline = new vis.Timeline(container, items, options);
        }, 10)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DashboardHome.vue